export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.8-1520.33",
  commitId: "d6e37ddf4d7ff3f81b2ea8e8d95f7751327d705f",
  commitTime: "2026-07-08T15:20:33.000Z",
});
